import { UserServiceAccount } from '@/api/generatedApi';
import { DeleteModal } from '@/components/modals/DeleteModal';
import { useDeleteServiceAccount } from '@/hooks/api/service-accounts/useDeleteServiceAccount';

export const DeleteServiceAccountModal = ({
  isOpen,
  onClose,
  serviceAccount,
  onSuccess,
}: {
  isOpen: boolean;
  onClose: () => void;
  serviceAccount?: UserServiceAccount;
  onSuccess?: () => void;
}) => {
  return (
    serviceAccount?.id && (
      <DeleteModal
        title='Delete Service Account'
        isOpen={isOpen}
        onClose={onClose}
        useHook={useDeleteServiceAccount}
        mutateParams={serviceAccount.id}
        item={serviceAccount}
        itemName={serviceAccount.name}
        onConfirm={onSuccess}
        alertSeverity='warning'
        alertMessage='Any applications using this service account will immediately lose access.'
      />
    )
  );
};
